/**
 Z-index order
 - Update Requires  (10.000)
 - Show Update password  (1.001)
 - Urgent, Update Recommend, What news (1.000)
 - Last normal notification (900)
 */
function bootstrap() {
    // Bootstrap angular with body
    document.body.classList.add('internal');
    
    // Fix for cordova
    if (window['cordova']) {
        document.body.classList.add('fullscreen');
    }
    
    try {
        angular.bootstrap(document.body, ['internal']);
    } catch (error) {
        console.error(error);
    }    
}
console.log('cordova support:' + (window['cordova'] ? true : false));

if (window['cordova']) {
    document.addEventListener("deviceready", () => {
        let config = window['config'];
        // Check and Grant permission for notification Android
        if (device.platform === 'Android') {
            // Check and Grant permission for notification Android 13+ iOS
            FirebasePlugin.hasPermission((hasNotificationPermission) => {
                console.log('hasNotificationPermission: ', hasNotificationPermission);
                if (hasNotificationPermission) {
                    config.hasNotificationPermission = hasNotificationPermission;
                    bootstrap();
                } else {
                    // Only ask permission only one time
                    if (localStorage.getItem('grantedPermission') !== "1") {
                        // GF-1306: #1,grantedPermission = 1 if user choose yes|no. If user don't choose any ,  not set grantedPermission 
                        // Only ask permission if android 13+, otherwise (Android 12) can't ask permission
                        if(device.sdkVersion>=33){ // Android  13+
                            FirebasePlugin.grantPermission((grantValue) => {
                                localStorage.setItem('grantedPermission', "1");
                                config.hasNotificationPermission = grantValue;
                                bootstrap();
                            }, () => {
                                localStorage.setItem('grantedPermission', "1");
                                config.hasNotificationPermission = false;
                                bootstrap();
                            });
                        } else {
                            localStorage.setItem('grantedPermission', "1");
                            config.hasNotificationPermission = false;
                            bootstrap();
                        }
                    } else {
                        config.hasNotificationPermission = false;
                        bootstrap();
                    }
                }
            }, () => {
                config.hasNotificationPermission = false;
                bootstrap();
            });
        }

        // Check and Grant permission for notification iOS
        if (device.platform === 'iOS') {
            FirebasePlugin.hasPermission((hasNotificationPermission) => {
                console.log('hasNotificationPermission: ', hasNotificationPermission);
                if (hasNotificationPermission) {
                    config.hasNotificationPermission = hasNotificationPermission;
                    bootstrap();
                } else {
                    cordova.plugins.diagnostic.requestRemoteNotificationsAuthorization({
                        successCallback: function () {
                            FirebasePlugin.registerRemoteNotifications(() => { // Register Remote Notifications for current app
                                config.hasNotificationPermission = true;
                                bootstrap();
                            });
                        },
                        errorCallback: function () {
                            config.hasNotificationPermission = false;
                            bootstrap();
                        },
                        types: [
                            cordova.plugins.diagnostic.remoteNotificationType.ALERT,
                            cordova.plugins.diagnostic.remoteNotificationType.SOUND,
                            cordova.plugins.diagnostic.remoteNotificationType.BADGE
                        ],
                        omitRegistration: true
                    });
                }

            }, () => {
                config.hasNotificationPermission = false;
                bootstrap();
            });
        }
    }, false);
} else {
    bootstrap();
}
